import validate from "/azp/_work/1/s/majority-com/node_modules/nuxt/dist/pages/runtime/validate.js";
import acquisition_45global from "/azp/_work/1/s/majority-com/middleware/acquisition.global.js";
import footer_45global from "/azp/_work/1/s/majority-com/middleware/footer.global.js";
import guard_45global from "/azp/_work/1/s/majority-com/middleware/guard.global.js";
import legal_45redirect_45global from "/azp/_work/1/s/majority-com/middleware/legal-redirect.global.js";
import query_45user_45context_45global from "/azp/_work/1/s/majority-com/middleware/query-user-context.global.js";
import route_45guard_45global from "/azp/_work/1/s/majority-com/middleware/route-guard.global.js";
import route_45global from "/azp/_work/1/s/majority-com/middleware/route.global.js";
import set_45locale_45global from "/azp/_work/1/s/majority-com/middleware/set-locale.global.js";
import user_45agent_45global from "/azp/_work/1/s/majority-com/middleware/user-agent.global.js";
import manifest_45route_45rule from "/azp/_work/1/s/majority-com/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  acquisition_45global,
  footer_45global,
  guard_45global,
  legal_45redirect_45global,
  query_45user_45context_45global,
  route_45guard_45global,
  route_45global,
  set_45locale_45global,
  user_45agent_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  community: () => import("/azp/_work/1/s/majority-com/middleware/community.js"),
  "country-redirect": () => import("/azp/_work/1/s/majority-com/middleware/country-redirect.js"),
  "diaspora-redirect": () => import("/azp/_work/1/s/majority-com/middleware/diaspora-redirect.js")
}